import { Link } from '@fluentui/react';
import * as React from 'react';
import { MainTitle } from './Help.resources';
import { getClassNames } from './HelpView.styles';
const initialHelpViewClassNames = getClassNames();

export const HelpPanelLinks = (props: { hrefLink: string; target: string; id: string; text: string }): JSX.Element => {
    return (
        <>
            <div className={initialHelpViewClassNames.helpTextBreak} />
            <Link
                className={initialHelpViewClassNames.link}
                href={props.hrefLink}
                target={props.target}
                id={props.id}
                aria-label={`${MainTitle.other} ${props.text}`}
            >
                <span aria-level={2}>{props.text}</span>
            </Link>
        </>
    );
};
